const read = (k: string, fallback: any) => {
  try {
    const v = localStorage.getItem(k);
    return v ? JSON.parse(v) : fallback;
  } catch {
    return fallback;
  }
};
const write = (k: string, v: any) => {
  try {
    localStorage.setItem(k, JSON.stringify(v));
  } catch {
    // OBS-11 a-ignore: localStorage throws in private mode / when full; this is a best-effort cache and the app works without it.
  }
};

const KEYS = {
  clientPrograms: 'coachd-client-programs',
  programTemplates: 'coachd-program-templates',
  clientNutritionPlans: 'coach-client-nutrition-plans',
  nutritionTemplates: 'coach-nutrition-templates',
  clientEvents: 'coachd-client-events',
};

export const localAppStore = {
  async getClientPrograms() {
    return read(KEYS.clientPrograms, []);
  },
  async setClientPrograms(rows: any[]) {
    write(KEYS.clientPrograms, rows);
  },

  async getProgramTemplates() {
    return read(KEYS.programTemplates, []);
  },
  async setProgramTemplates(rows: any[]) {
    write(KEYS.programTemplates, rows);
  },

  async getClientNutritionPlans() {
    return read(KEYS.clientNutritionPlans, []);
  },
  async setClientNutritionPlans(rows: any[]) {
    write(KEYS.clientNutritionPlans, rows);
  },

  async getNutritionTemplates() {
    return read(KEYS.nutritionTemplates, []);
  },
  async setNutritionTemplates(rows: any[]) {
    write(KEYS.nutritionTemplates, rows);
  },

  async getClientEvents() {
    return read(KEYS.clientEvents, []);
  },
  async setClientEvents(rows: any[]) {
    write(KEYS.clientEvents, rows);
  },
};
